function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "theater_comedy");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#666666",
  d: "M18.984 8.063q0.422 0 0.727-0.281t0.305-0.703-0.305-0.703-0.727-0.281-0.703 0.281-0.281 0.703 0.281 0.703 0.703 0.281zM14.016 8.063q0.422 0 0.703-0.281t0.281-0.703-0.281-0.703-0.703-0.281-0.727 0.281-0.305 0.703 0.305 0.703 0.727 0.281zM11.016 3h10.969v6.516q0 2.297-1.594 3.891t-3.891 1.594q-1.266 0-2.484-0.609v-2.906h4.969q0-0.609-0.727-1.055t-1.758-0.445-1.758 0.445-0.727 1.055v-2.484h-3v-6zM5.016 12.984q-0.422 0-0.727 0.305t-0.305 0.727 0.305 0.703 0.727 0.281 0.703-0.281 0.281-0.703-0.281-0.727-0.703-0.305zM9.984 12.984q-0.422 0-0.703 0.305t-0.281 0.727 0.281 0.703 0.703 0.281 0.727-0.281 0.305-0.703-0.305-0.727-0.727-0.305zM7.5 18.516q1.031 0 1.758-0.445t0.727-1.055h-4.969q0 0.609 0.727 1.055t1.758 0.445zM2.016 16.5v-6.516h10.969v6.516q0 2.297-1.594 3.891t-3.891 1.594-3.891-1.594-1.594-3.891z"
});

var SvgHobbies = function SvgHobbies(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHobbies, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hobbies.2ffb30fd.svg";
export { ForwardRef as ReactComponent };